<template>
  <Page>
    <div class="resportList">
      <div>
        <!-- 顶部 -->
        <div class="headerTitle-top">
          <div class="flex-title">门店：</div>
          <div class="picker-alls" @click="pickerAll">{{dealerName||"全部"}}
            <div class="triangle_border_down"></div>
          </div>
        </div>
        <!-- 概况统计 -->
        <div class="general-statistics flex">
          <div class="flex-title">概况统计：</div>
          <div class="flex timeList">
            <div v-for="(item,index) in  timeList" v-bind:key="index"  :class="item.edit==true?'timeListActive':''"  @click="switchDate(index)" >{{item.name}}</div>
          </div>
        </div>
        <!-- 数据展示列表 -->
        <div class="statisticsList">
          <div
            v-for="(item,index) in statisticsList"
            v-bind:key="index"
            class="statisticsList-item"
          >
            <div class="C">{{item.name}}</div>
            <div class="C" v-if="item.id==0">{{item.price?$numeral(item.price).format('0,0.00'):0}}</div>
            <div class="C" v-if="item.id==1 && index == 2">{{statisticsList[0].price == 0 ? "-" : $numeral(item.price).format('0,0.00')+'%'}}</div>
            <div class="C" v-if="item.id==1 && index == 3">{{dailyBasic.lastYearAmount == 0 ? "-" : $numeral(item.price).format('0,0.00')+'%'}}</div>

          </div>
        </div>
        <div class="statisticsList clientList">
          <div v-for="(item,index) in clientList" v-bind:key="index" class="statisticsList-item">
            <div class="C">{{item.name}}</div>
            <div class="C"  v-if="item.id==0">{{item.price?$numeral(item.price).format('0,0.00'):0}}</div>
            <div class="C"  v-if="item.id==1">{{item.price?$numeral(item.price).format('0,0'):0}}</div>
          </div>
        </div>
      </div>

      <!-- 切换 -->
      <van-tabs v-model="active"  @click="tabsShow(active)">
        <van-tab :title="'新客（'+totalRowA+'）'">
            <!-- 新客 -->
            <van-list v-model="loadingA" :finished="finishedA" finished-text="没有更多了"    @load="onLoadA">
                <div class="scroll-view-list-item" v-for="(item,index) in listA" v-bind:key="index" @click="toClientDetail(item.AccountId)">
                <div class="information-list">
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">客户</div>
                        <div>{{item.name||''}}</div>
                    </div>
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">性别</div>
                        <div>{{item.gender=='0'?'男':'女'}}</div>
                    </div>
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">手机号</div>
                        <div>{{item.mobile||''}}</div>
                    </div>
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">VIP等级</div>
                                          <div class="VIP-starts"  v-if="item.vip" :style="'width:'+item.vip*.4+'rem'">
                                                <img
                                                      v-for="(item,index) in item.vip"
                                                      v-bind:key="index"
                                                      :src="require('@/assets/img/vipStar.png')"
                                                      class="start"
                                                      alt=""
                                                      srcset=""
                                                >
                                          </div>
                    </div>
                </div>
                </div>
            </van-list>
        </van-tab>
        <van-tab  :title="'老客（'+totalRowB+'）'">
            <!-- 旧客 -->
          <van-list v-model="loadingB" :finished="finishedB" finished-text="没有更多了"   @load="onLoadB">
            <div class="scroll-view-list-item" v-for="(item,index) in listB" v-bind:key="index" @click="toClientDetail(item.AccountId)">
                <div class="information-list" >
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">客户</div>
                        <div>{{item.name||''}}</div>
                    </div>
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">性别</div>
                        <div>{{item.gender=='0'?'男':'女'}}</div>
                    </div>
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">手机号</div>
                        <div>{{item.mobile||''}}</div>
                    </div>
                    <div class="information-list-item item-lists flex activeFont">
                        <div class="title-LF">VIP等级</div>
                                          <div class="VIP-starts"  v-if="item.vip" :style="'width:'+item.vip*.4+'rem'">
                                                <img
                                                      v-for="(item,index) in item.vip"
                                                      v-bind:key="index"
                                                      :src="require('@/assets/img/vipStar.png')"
                                                      class="start"
                                                      alt=""
                                                      srcset=""
                                                >
                                          </div>
                    </div>
                </div>
            </div>
          </van-list>

        </van-tab>
        <van-tab :title="'购买记录（'+totalRowC+'）'">

            <!-- 购买记录 -->
          <van-list v-model="loadingC" :finished="finishedC" finished-text="没有更多了"    @load="onLoadC">
            <div class="scroll-view-list-item" v-for="(item,index) in listC"   v-bind:key="index">
              <div class="information-list">
                <div class="information-list-item item-lists flex activeFont">
                    <div  class="title-LF">购买日期</div>
                    <div>{{item.date?item.date.replace(/-/g,"/"):''}}</div>
                </div>
                <div class="information-list-item item-lists flex activeFont">
                    <div  class="title-LF">零售价</div>
                    <div>{{item.amount?$numeral(item.amount).format('0,0.00'):''}}</div>
                </div>
                <div class="information-list-item item-lists flex activeFont">
                    <div  class="title-LF">产品分类</div>
                    <div>{{item.products2ndType||''}}</div>
                </div>
                <div class="information-list-item item-lists flex activeFont">
                    <div  class="title-LF">未税金额</div>
                    <div>{{item.amountBefTax ? $numeral(item.amountBefTax).format('0,0.00') : ''}}</div>
                </div>
                <div class="information-list-item item-lists flex activeFont">
                    <div  class="title-LF">中文名称</div>
                    <div class="ep">{{item.productNameCH||''}}</div>
                </div>
                <div class="information-list-item item-lists flex activeFont">
                    <div  class="title-LF">购买渠道</div>
                    <div>{{item.deptName||''}}</div>
                </div>
              </div>
            </div>
          </van-list>

            </van-tab>
      </van-tabs>


    <van-popup v-model="show" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title=""
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
        :value-key="'deptName'"
        class="van-picker-li"
      />
    </van-popup>
      <!-- 分页数据计算 -->
      <div class="loaded" v-show="active==0">已加载 {{this.listA.length}}/{{totalRowA}}</div>
      <div class="loaded" v-show="active==1">已加载 {{this.listB.length}}/{{totalRowB}}</div>
      <div class="loaded" v-show="active==2">已加载 {{this.listC.length}}/{{totalRowC}}</div>
    </div>
  </Page>
</template>





<script>
export default {
  data() {
    return {
      show:false,
      columns:[],
      timeList: [
        {
          name: "日",
          edit: true,
          id:1
        },
        {
          name: "周",
          edit: false,
          id:2
        },
        {
          name: "月",
          edit: false,
          id:3
        },
        {
          name: "季",
          edit: false,
          id:4
        },
        {
          name: "年",
          edit: false,
          id:5
        }
      ],
      statisticsList: [
        {
          name: "昨日销售金额（元）",
          price: 0,
          id:0
        },
        {
          name: "今日销售金额（元）",
          price: 0,
          id:0
        },
        {
          name: "环比",
          price: "0%",
          id:1
        },
        {
          name: "同比",
          price: "0%",
          id:1
        }
      ],
      clientList: [
        {
          name: "客单价",
          price: 0,
          id:0
        },
        {
          name: "到店客流",
          price: 0,
          id:1
        },
        {
          name: "新客",
          price: "0",
          id:1
        },
        {
          name: "老客",
          price: "0",
          id:1
        }
      ],
      listA: [],        //新客列表
      listC: [],        //旧客列表
      listB: [],        //购买记录列表
      totalRowA:0,
      totalRowB:0,
      totalRowC:0,
      loadingA: false,
      finishedA: false,
      loadingB: false,
      finishedB: false,
      loadingC: false,
      finishedC: false,
      totalRow: 100,
      active: 0,
      pageSizeA:10,             //新客
      pageNumberA:1,          //新客
      pageSizeB:10,             //老客
      pageNumberB:1,          //老客
      pageSizeC:10,             //购买记录
      pageNumberC:1,          //购买记录
      dealerId:this.$wxuserUtil.getDeptId(),                                           //门店ID
      dealerName:this.$wxuserUtil.getDeptName(),                                       //默认为空
      // dealerId:"",                                           //门店ID
      // dealerName:"",                                       //默认为空
      dateType:"1",             //日期
      Dealer:[],                //经销商-门店列表
      types:0,                  // 0 新客  1 老客   2 购买记录
      dailyBasic : {} //零售报表基础信息
    };
  },
  methods: {
    pickerAll() {
        this.columns=this.Dealer;
        this.show=true;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    },
   //新客列表分页
   onLoadA(){
       setTimeout(()=>{
                    this.pageSizeA=10;
                    this.pageNumberA= parseInt(this.pageNumberA+1)
                    this.loadingA=false;
                    this.finishedA=false;
                    this.getSoldDailyNewCustList(2,this.pageNumberA);
       },500)
   },
   //旧客列表分页
   onLoadB(){
        setTimeout(()=>{
                    this.pageSizeB=10;
                    this.pageNumberB= parseInt(this.pageNumberB+1)
                    this.loadingB=false;
                    this.finishedB=false;
                    this.getSoldDailyOldCustList(2,this.pageNumberB);
       },500)
   },
   //购买记录分页
   onLoadC(){
         setTimeout(()=>{
                    this.pageSizeC=10;
                    this.pageNumberC= parseInt(this.pageNumberC+1)
                    this.loadingC=false;
                    this.finishedC=false;
                    this.getSoldDailyBuyRecords(2,this.pageNumberC);
       },500)
   },
   onCancel(){
       this.show=false;
   },

  /**
   * 缓存部门
   */
  cacheDept : function(){
    this.$wxuserUtil.storage.set("reportList_deptId",this.dealerId);
    this.$wxuserUtil.storage.set("reportList_deptName",this.dealerName);
  },
  /**
   * 加载部门缓存
   */
  loadCacheDept : function(){
      let deptId = this.$wxuserUtil.storage.get("reportList_deptId");
      let deptName = this.$wxuserUtil.storage.get("reportList_deptName");

      if(deptId){
        this.dealerId=deptId;
      }
      if(deptName){
        this.dealerName=deptName;
      }
  },

   onConfirm(val){
     this.dealerName=val.deptName;
     this.dealerId=val.deptId;
     this.cacheDept();

     this.show=false;
     this.getSoldDailyBasic();
     this.getSoldDailyNewCustList(1,1);
     this.getSoldDailyOldCustList(1,1);
     this.getSoldDailyBuyRecords(1,1);
   },
   /**
    *
    *  客户接口 （新客，老客）
    *  @param {String}  salesId    销售用户
    *  @param {Number}  dateType   时间类型（1、日 2、周 3、月 4、季 5、年 6、全）
    *  @param {String}  dealerId   门店ID
    *
    */
    getSoldDailyNewCustList(ID,Page){
         let  data   ={
             salesId:this.$wxuserUtil.getUserId(),
             dateType:this.dateType,
             dealerId:this.dealerId,
             pageSize:this.pageSizeA,
             pageNumber:Page
         }
        var Response  =  this.$api.getSoldDailyNewCustList(data)
            console.log("新客列表",Response)
            if(Response.success){
                if(ID==1){
                    this.listA=this.CGvip(Response.data.list)||[]
                    this.totalRowA=Response.data.totalRow;
                    if(Response.data.list.length<9||!this.listA){
                        this.finishedA=true
                        this.loadingA=false
                    }
                }
              if(ID==2){
                   console.log("分页加载",Response.data)
                             if(Response.data.list.length==0){
                              this.finishedA = true;
                             }else{
                              this.finishedA=false;
                              this.listA=this.listA.concat(this.CGvip(Response.data.list)||[])
                             }
              }
            }else{
                this.$title(Response.msg)
            }
    },
    getSoldDailyOldCustList(ID,Page){
        let data   ={
            salesId:this.$wxuserUtil.getUserId(),
            dateType:this.dateType,
            dealerId:this.dealerId,
            pageSize:this.pageSizeB,
            pageNumber:Page
        }
        var Response = this.$api.getSoldDailyOldCustList(data)
            console.log("旧客列表",Response)
            if(Response.success){
                if(ID==1){
                    this.listB=this.CGvip(Response.data.list)||[]
                    this.totalRowB=Response.data.totalRow;
                    if(Response.data.list.length<9||!this.listA){
                        this.finishedB=true
                        this.loadingB=false
                    }
                }
                if(ID==2){
                                if(Response.data.list.length==0){
                                this.finishedB = true;
                                }else{
                                this.finishedB=false;
                                this.listB=this.listB.concat(this.CGvip(Response.data.list)||[])
                                }
                }
            }else{
                this.$title(Response.msg)
            }
    },
   /**
    *
    * 零售报表-购买记录
    * @param {String}  salesId    销售用户
    * @param {String}  dealerId   门店ID
    * @param {Number}  dateType   时间类型（1、日 2、周 3、月 4、季 5、年 6、全）
    *
    **/
    getSoldDailyBuyRecords(ID,Page){
      let  data  ={
            salesId:this.$wxuserUtil.getUserId(),
            dateType:this.dateType,
            dealerId:this.dealerId,
            pageSize:this.pageSizeC,
            pageNumber:Page
      }
    var Response = this.$api.getSoldDailyBuyRecords(data)
          console.log("购买记录",Response)
            if(Response.success){
                if(ID==1){
                    this.listC=Response.data.list||[]
                    this.totalRowC=Response.data.totalRow;
                    if(Response.data.list.length<9||!this.listA){
                        this.finishedC=true
                        this.loadingC=false
                    }
                }
                if(ID==2){
                                if(Response.data.list.length==0){
                                this.finishedC = true;
                                }else{
                                this.finishedC=false;
                                this.listC=this.listC.concat(this.CGvip(Response.data.list)||[])
                                }
                }
            }else{
                this.$title(Response.msg)
            }
    },
    /**
     *
     *  零售报表-概况统计
     *
     */
    getSoldDailyBasic(){
        let data  ={
            salesId:this.$wxuserUtil.getUserId(),
            dealerId:this.dealerId,
            dateType:this.dateType,
        }
        this.$api.getSoldDailyBasic(data).then(Response=>{
              if(Response.success){
                 console.log("获取",Response)
                 let $data      =   Response.data;
                 this.dailyBasic = $data;
                 let $statisticsList=this.statisticsList;
                 let $clientList    =this.clientList;
                 $statisticsList[0]['price']=$data.yesterdayAmount||0
                 $statisticsList[1]['price']=$data.todayAmount||0
                 $statisticsList[2]['price']=$data.chainRatio||0
                 $statisticsList[3]['price']=$data.yearOnyear||0
                 $clientList[0]['price']=$data.CustomerUnitPrice||0;
                 $clientList[1]['price']=$data.sumVisitCnt||0;
                 $clientList[2]['price']=$data.newCustomer||0;
                 $clientList[3]['price']=$data.oldCustomer||0;
                this.clientList=$clientList;
                this.statisticsList=$statisticsList;
              }else{
                  this.$title(Response.msg)
              }
        }).catch(err=>{

        })
    },
    /***
     *
     *  获取经销商 - 门店
     *
     */
    getDealerlist() {
      this.$api.getDealerlist({ salesId: this.$wxuserUtil.getUserId() })
        .then(Response => {
          console.log("经销商列表",Response)
          let list=[{deptName:"全部",deptId:""}]
          this.Dealer = list.concat(Response.data);
          this.getSoldDailyBasic();
          this.getSoldDailyNewCustList(1,1);
          this.getSoldDailyOldCustList(1,1);
          this.getSoldDailyBuyRecords(1,1);
        });
    },
    /**
     *
     * 日期切换
     *
     */
    switchDate(index){
       let $data   =  this.timeList;
       $data[index]['edit']=true;
       for(let i=0;i<$data.length;i++){
            if(i>index||i<index){
             $data[i]['edit']=false;
            }
       }
       this.timeList=$data;
       this.dateType=this.timeList[index]['id']
       this.getSoldDailyBasic();
       this.getSoldDailyNewCustList(1,1);
       this.getSoldDailyOldCustList(1,1);
       this.getSoldDailyBuyRecords(1,1);
       console.log("当前ID",index);
       if(index==0){
        this.statisticsList[0]['name']="昨日销售金额（元）";
        this.statisticsList[1]['name']="今日销售金额（元）";
       }
       if(index==1){
        this.statisticsList[0]['name']="上周销售金额（元）";
        this.statisticsList[1]['name']="本周销售金额（元）";
       }
       if(index==2){
        this.statisticsList[0]['name']="上月销售金额（元）";
        this.statisticsList[1]['name']="本月销售金额（元）";
       }
       if(index==3){
        this.statisticsList[0]['name']="上季度销售金额（元）";
        this.statisticsList[1]['name']="本季度销售金额（元）";
       }
       if(index==4){
        this.statisticsList[0]['name']="去年销售金额（元）";
        this.statisticsList[1]['name']="本年销售金额（元）";
       }
       if(index==5){
        this.statisticsList[0]['name']="昨日销售金额（元）";
        this.statisticsList[1]['name']="今日销售金额（元）";
       }
    },
    /**
     *
     * 标签页 切换
     *
     */
    tabsShow(val){
        console.log("标签页切换",val)
        if(val==0){
             this.listA=[];
             this.pageSizeA=10;
             this.pageNumberA=1;
             this.loadingA=false;
             this.finishedA=false;
             this.getSoldDailyNewCustList(1,1);
        }
        if(val==1){
             this.listB=[];
             this.pageSizeB=10;
             this.pageNumberB=1;
             this.loadingB=false;
             this.finishedB=false;
             this.getSoldDailyOldCustList(1,1);
        }
        if(val==2){
             this.listC=[];
             this.pageSizeC=10;
             this.pageNumberC=1;
             this.loadingC=false;
             this.finishedC=false;
             this.getSoldDailyBuyRecords(1,1);
        }
    },
   /**
    *
    * VIP等级处理
    *
    **/
    CGvip(DATA){
       if(Array.isArray(DATA)){
           for(let i=0;i<DATA.length;i++){
                 DATA[i]['vip']= DATA[i]['vip']?DATA[i]['vip']/10:0
           }
           return  DATA;
       }else{
           return [];
       }
    },
   /**
     *   客户详情
     **/
    toClientDetail(ID){
      console.log("ID",ID)
      if(ID){
        this.$router.push({ path: "/ClientDetails", query: {custId:ID,showCC:true,IdCode:this.$parent.IdCode} })
      }
    },
  },

  mounted(){
    this.loadCacheDept();
    this.getDealerlist();
  }
};
</script>


<style lang="less" src="~p/pageView-resportList.less"></style>



// WEBPACK FOOTER //
// src/components/reports/resportList.vue